<div style="position: absolute; left: -15420px">
  <div style="width: 100%; display: flex">
    <div id="generateBarcode">
      <div style="display: flex; flex-wrap: wrap; gap: 10px">
        <div *ngFor="let item of dataToPrint">
          <div
            style="
              padding: 10px;
              box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.3);
              width: 360px;
            "
          >
            <mat-card style="max-width: 360px; margin: 4px">
              <div
                style="
                  display: flex;
                  justify-content: space-between;
                  font-size: 23px;
                "
              >
                <p style="text-wrap: wrap">{{ item?.productName }}</p>
                <p style="text-wrap: wrap">{{ item.productNumber }}</p>
              </div>
              <mat-card-header
                style="
                  display: flex;
                  justify-content: space-between;
                  margin-bottom: 5px;
                "
              >
                <div mat-card-avatar style="display: flex; gap: 10px">
                  <div>
                    <ng-container *ngIf="item?.productImage">
                      <img
                        [src]="item.productImage"
                        alt=""
                        style="
                          background-size: cover;
                          width: 100px;
                          height: 100px;
                        "
                      />
                    </ng-container>
                    <ng-container *ngIf="!item?.productImage">
                      <img
                        src="assets/images/ez-logo.png"
                        alt=""
                        style="
                          background-size: cover;
                          width: 100px;
                          height: 100px;
                        "
                      />
                    </ng-container>
                  </div>
                  <div style="font-size: 20px">
                    <mat-card-content style="line-height: 32px"
                      ><span style="text-wrap: wrap">{{ item.udf2 }}</span>
                      <br />{{ item.priceLevel | customCurrency }}<br />{{
                        item.dimensions
                      }}</mat-card-content
                    >
                  </div>
                </div>
                <div>
                  <mat-card-content *ngIf="!item.type">
                    <qrcode
                      [qrdata]="item.productNumber"
                      [allowEmptyString]="true"
                      [alt]="'A custom alt attribute'"
                      [ariaLabel]="
                        'QR Code image with the following content...'
                      "
                      [cssClass]="'center'"
                      [colorDark]="'#000000ff'"
                      [colorLight]="'#ffffffff'"
                      [elementType]="'img'"
                      [errorCorrectionLevel]="'M'"
                      [margin]="4"
                      [scale]="1"
                      [title]="'A custom title attribute'"
                      [width]="110"
                    ></qrcode>
                  </mat-card-content>
                </div>
              </mat-card-header>
              <mat-card-content *ngIf="item.type">
                <div style="width: 100%">
                  <ngx-barcode
                    class="center-block"
                    style="
                      max-height: 0.35in !important;
                      width: 20%;
                      opacity: 1;
                    "
                    [bc-value]="item.productNumber"
                    [bc-width]="3.5"
                    [bc-height]="27"
                  >
                  </ngx-barcode>
                </div>
              </mat-card-content>
            </mat-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
